import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AreaModel } from 'app/model/cliente/area.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AreaService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getAreas(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-areas', this.httpOptions);
  }

  getAreasUsuarioCliente(idCliente: number): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/view/listar-areas-usuario/${idCliente}`, this.httpOptions);
  }

  getUsersArea(idArea: number): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/view/listar-usuarios-area/${idArea}`, this.httpOptions);
  }

  getPageAreas(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-areas?page=${page}&size=${size}`, this.httpOptions);
  }

  postArea(area: AreaModel, idCliente: number): Observable<AreaModel> {
    return this.httpClient.post<any>(this.apiURL + '/new/adicionar-area/' + idCliente, area, this.httpOptions);
  }


  putArea(area: AreaModel, idCliente: number): Observable<AreaModel> {
    return this.httpClient.put<AreaModel>(this.apiURL + '/edit/editar-area/' + idCliente, area, this.httpOptions);
  }

  getAreasCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/listar-areas-cliente/' + id, this.httpOptions);
  }

  getAreasIdCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/listar-areas-id-cliente/' + id, this.httpOptions);
  }

  deleteArea(id: any) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + '/delete/apagar-area/' + id, { headers, responseType: 'json' });
  }

  getUserAreas(idCliente: any) {
    return this.httpClient.get<any>(this.apiURL + `/usuarios/listar/${idCliente}`, this.httpOptions);
  }

  getLastCodigo(idCliente: number) {
    return this.httpClient.get(this.apiURL + `/codigo-ultima-area/${idCliente}`, this.httpOptions);
  }

  getDescricaoAreasCliente(clienteId: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + `/listar-areas-cliente-sign/${clienteId}`, this.httpOptions);
  }




}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/area.service.ts